<template>
  <transition name="fade">
  <div class="dia-login" v-if="showDiaLogin">
    <div class="mask-all"></div>
    <div class="login-cont login-register">
      <div class="form-ipt">
        <div class="form-title">登 录 / 注 册<i class="close-btn el-icon-circle-close" @click="closeDiaLogin"></i></div>
        <div class="form-cont">
          <el-input placeholder="请输入手机号" v-model="registerPhoneNum"></el-input>
          <div class="form-item">
            <el-input class="left-ipt" v-model="registerImgCode" placeholder="请输入验证码"></el-input>
            <img class="right-btn" :src="registerCheckImg" alt="">
          </div>
          <div class="form-item">
            <el-input class="left-ipt" v-model="registerYzm" placeholder="请输入6位短信验证码"></el-input>
              <el-button
                      class="right-btn"
                      :type="time === 0 ? 'primary' : 'info'"
                      :disabled="time === 0 ? false : true"
              >
                  {{time === 0 ? '发送验证码' : time + '秒后重发'}}
              </el-button>
          </div>
          <div class="agree">
            <el-checkbox v-model="xieyi">我已阅读并接受</el-checkbox>
            <span class="xieyi">《人人动画网用户使用协议》</span>及
            <span class="xieyi">《隐私政策》</span>
          </div>
          <div class="login-btn">
            <el-button class="btn" size="medium">登录/注册</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  </transition>
</template>

<script type="text/ecmascript-6">
export default {
  components: {

  },
  data () {
    return {
      registerImgCodeShow:false,
        registerPhoneNum: '',
        registerImgCode: '',
        registerCheckImg: require('@/assets/images/yanzhengma_img.jpg'),
        registerYzm: '',
        time: 0,
        fromUrl:"",
        fromQuery:"",
        xieyi: true,
        isRegister:false,
        showDiaLogin: false
    }
  },
  methods: {
    closeDiaLogin () {
      this.showDiaLogin = false
    }
  }
}
</script>

<style scoped lang="less">
@import "../../../assets/less/login.less";
.dia-login{
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1889;
  .mask-all{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .5);
  }
  .login-cont.login-register{
    background: none;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
